import { appendVersionParam } from '@hakimo-ui/hakimo/util';
import { Alarm, DataVersion } from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
dayjs.extend(utc);

export function useOnClickRow(dataVersion?: DataVersion) {
  const navigate = useNavigate();

  const onClickRow = useCallback(
    (alarm: Alarm, event: React.MouseEvent | React.KeyboardEvent) => {
      const timestamp = alarm.timestamp;
      const date = dayjs.utc(timestamp);
      const partitionKey = date.format('YYYYMM');
      const url = appendVersionParam(
        `/alarms/${alarm.id}?partitionKey=${partitionKey}`,
        dataVersion
      );
      const isNewTab = event.ctrlKey || event.metaKey;
      isNewTab
        ? window.open(url, '_blank', 'noopener,noreferrer')
        : navigate(url);
    },
    [navigate, dataVersion]
  );

  return onClickRow;
}
